import React from 'react';
import usePaymentDetailsVm from './payment-details-vm';
import styles from '../../gap-coverage.module.css';
import { GapWaiverResponse } from '../../services';

interface PaymentDetailsProps {
  gapWaiver: GapWaiverResponse;
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({ gapWaiver }) => {
  const { subSectionElements } = usePaymentDetailsVm(gapWaiver);

  const getTestId = (key: number): string => {
    const testIdMap: Record<number, string> = {
      1: 'qe-gap-new-monthly-payment',
      2: 'qe-gap-current-monthly-payment',
      3: 'qe-gap-additional-down-payment',
      4: 'qe-gap-additional-monthly-payment',
      5: 'qe-gap-additional-term'
    };
    return testIdMap[key] || '';
  };

  return (
    <div className={styles.paymentDetails}>
      {gapWaiver.isApplied && (
        <div className={styles.paymentDetailsHeader}>You're protected with GAP coverage</div>
      )}

      {subSectionElements.map(
        e =>
          e.isVisible && (
            <div className={styles.paymentDetailsRow} key={e.key} data-testid={getTestId(e.key)}>
              <span className={styles.paymentDetailsLabel}>{e.text}</span>
              <span className={styles.paymentDetailsValue}>{e.value}</span>
            </div>
          )
      )}

      {!gapWaiver.isApplied && (
        <div className={styles.totalPrice} data-testid="qe-gap-coverage-price">
          Total price for Gap Coverage ${gapWaiver.price}
        </div>
      )}
    </div>
  );
};

export default PaymentDetails;
